window.TEV_EV_DATA = [
  {
    id: "tesla_model_3_rwd",
    status: "active",
    brand: "Tesla",
    model: "Model 3",
    variant: "RWD",
    display_name: "Tesla Model 3 RWD",
    segment: "premium_family",
    body_type: "saloon",
    size_class: "D",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 39990,
      used_price_bands_gbp: {
        "2_4": 25995,
        "5_7": 19995,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: null,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 344,
      estimated_kwh_per_mile: 0.16,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: null,
      dc_kw: 170,
      home_charge_suitability: 8,
      public_charge_suitability: 9
    },

    practicality: {
      doors: 4,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 4,
      basic_miles: 60000,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_premium_family",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 8,
      range_confidence: 8,
      city_fit: 7,
      motorway_fit: 9,
      family_fit: 7,
      first_ev_friendliness: 8,
      charging_confidence: 9,
      premium_feel: 7,
      long_term_confidence: 8,
      tech_appeal: 9
    },

    buyer_tags: ["motorway", "tech", "first_ev", "premium"],

    notes: {
      short_reason: "Strong all-rounder with low running costs and good charging access.",
      tradeoff: "Not the cheapest upfront option for every buyer."
    }
  },

  {
    id: "hyundai_kona_electric_65",
    status: "active",
    brand: "Hyundai",
    model: "Kona Electric",
    variant: "65.4kWh",
    display_name: "Hyundai Kona Electric 65.4kWh",
    segment: "compact_suv",
    body_type: "suv",
    size_class: "C",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 35000,
      used_price_bands_gbp: {
        "2_4": 18995,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: 65.4,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 319,
      estimated_kwh_per_mile: 0.205,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: 7.4,
      dc_kw: 102,
      home_charge_suitability: 9,
      public_charge_suitability: 7
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 5,
      basic_miles: null,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_compact_suv",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 8,
      range_confidence: 8,
      city_fit: 8,
      motorway_fit: 7,
      family_fit: 8,
      first_ev_friendliness: 9,
      charging_confidence: 7,
      premium_feel: 6,
      long_term_confidence: 8,
      tech_appeal: 7
    },

    buyer_tags: ["family", "first_ev", "value"],

    notes: {
      short_reason: "Strong practical EV for first-time UK switchers.",
      tradeoff: "DC charging is not class-leading."
    }
  },

  {
    id: "bmw_i4_edrive40",
    status: "active",
    brand: "BMW",
    model: "i4",
    variant: "eDrive40",
    display_name: "BMW i4 eDrive40",
    segment: "premium_family",
    body_type: "gran-coupe",
    size_class: "D",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 51400,
      used_price_bands_gbp: {
        "2_4": 31995,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: null,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 365,
      estimated_kwh_per_mile: 0.18,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: 11,
      dc_kw: 205,
      home_charge_suitability: 8,
      public_charge_suitability: 8
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: null,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_premium_family",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: true
    },

    scores: {
      value: 7,
      range_confidence: 8,
      city_fit: 6,
      motorway_fit: 9,
      family_fit: 7,
      first_ev_friendliness: 7,
      charging_confidence: 8,
      premium_feel: 9,
      long_term_confidence: 8,
      tech_appeal: 8
    },

    buyer_tags: ["premium", "motorway", "tech"],

    notes: {
      short_reason: "Premium long-distance EV with strong refinement.",
      tradeoff: "Higher purchase price than mainstream rivals."
    }
  }
  ,
  {
    id: "tesla_model_y_rwd",
    status: "active",
    brand: "Tesla",
    model: "Model Y",
    variant: "RWD",
    display_name: "Tesla Model Y RWD",
    segment: "family_suv",
    body_type: "suv",
    size_class: "D",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 41990,
      used_price_bands_gbp: {
        "2_4": null,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: null,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 311,
      estimated_kwh_per_mile: 0.159,
      official_consumption_kwh_per_100km: 15.9
    },

    charging: {
      ac_kw: null,
      dc_kw: 250,
      home_charge_suitability: 8,
      public_charge_suitability: 9
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 4,
      basic_miles: 60000,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_family_suv",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 8,
      range_confidence: 8,
      city_fit: 6,
      motorway_fit: 9,
      family_fit: 9,
      first_ev_friendliness: 8,
      charging_confidence: 9,
      premium_feel: 7,
      long_term_confidence: 8,
      tech_appeal: 9
    },

    buyer_tags: ["family", "motorway", "tech"],

    notes: {
      short_reason: "Strong family EV with efficient running costs and fast charging.",
      tradeoff: "Still needs a proper used-price pass in the dataset."
    }
  },

  {
    id: "mg_mg4_urban_54",
    status: "active",
    brand: "MG",
    model: "MG4 EV",
    variant: "Urban 53.9kWh",
    display_name: "MG4 EV Urban 53.9kWh",
    segment: "small_hatch",
    body_type: "hatchback",
    size_class: "C",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 23495,
      used_price_bands_gbp: {
        "2_4": null,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: 53.9,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 258,
      estimated_kwh_per_mile: 0.209,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: null,
      dc_kw: null,
      home_charge_suitability: 9,
      public_charge_suitability: 7
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 7,
      basic_miles: 80000,
      battery_years: 8,
      battery_miles: 120000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_small_hatch",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 9,
      range_confidence: 7,
      city_fit: 8,
      motorway_fit: 7,
      family_fit: 6,
      first_ev_friendliness: 9,
      charging_confidence: 7,
      premium_feel: 5,
      long_term_confidence: 7,
      tech_appeal: 6
    },

    buyer_tags: ["budget", "first_ev", "value"],

    notes: {
      short_reason: "Strong value EV with good WLTP range for the price.",
      tradeoff: "Dataset still needs approved used-price benchmarks."
    }
  },

  {
    id: "vw_id4_pure_52",
    status: "active",
    brand: "Volkswagen",
    model: "ID.4",
    variant: "Pure 52kWh",
    display_name: "Volkswagen ID.4 Pure 52kWh",
    segment: "family_suv",
    body_type: "suv",
    size_class: "D",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 36995,
      used_price_bands_gbp: {
        "2_4": null,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: 52,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 222,
      estimated_kwh_per_mile: 0.234,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: null,
      dc_kw: null,
      home_charge_suitability: 8,
      public_charge_suitability: 7
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: 60000,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_family_suv",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 7,
      range_confidence: 6,
      city_fit: 6,
      motorway_fit: 7,
      family_fit: 8,
      first_ev_friendliness: 8,
      charging_confidence: 7,
      premium_feel: 6,
      long_term_confidence: 7,
      tech_appeal: 6
    },

    buyer_tags: ["family", "practical", "first_ev"],

    notes: {
      short_reason: "Practical family EV from a mainstream UK brand.",
      tradeoff: "Entry battery version gives a shorter official range."
    }
  },

  {
    id: "skoda_enyaq_edition_60",
    status: "active",
    brand: "Skoda",
    model: "Enyaq",
    variant: "Edition 60",
    display_name: "Skoda Enyaq Edition 60",
    segment: "family_suv",
    body_type: "suv",
    size_class: "D",
    launch_priority: 1,

    pricing: {
      new_price_gbp: 40110,
      used_price_bands_gbp: {
        "2_4": 27700,
        "5_7": null,
        "8_10": null
      }
    },

    battery: {
      usable_kwh: 59,
      gross_kwh: null
    },

    efficiency: {
      official_range_miles: 268,
      estimated_kwh_per_mile: 0.220,
      official_consumption_kwh_per_100km: null
    },

    charging: {
      ac_kw: 11,
      dc_kw: 165,
      home_charge_suitability: 8,
      public_charge_suitability: 8
    },

    practicality: {
      doors: 5,
      seats: 5,
      boot_litres: null
    },

    warranty: {
      basic_years: 3,
      basic_miles: 60000,
      battery_years: 8,
      battery_miles: 100000,
      battery_retention_percent: 70
    },

    cost_links: {
      maintenance_band: "ev_family_suv",
      ved_class: "zero_emission_standard",
      expensive_car_applicable_new: false
    },

    scores: {
      value: 8,
      range_confidence: 7,
      city_fit: 6,
      motorway_fit: 8,
      family_fit: 9,
      first_ev_friendliness: 8,
      charging_confidence: 8,
      premium_feel: 6,
      long_term_confidence: 8,
      tech_appeal: 6
    },

    buyer_tags: ["family", "space", "value"],

    notes: {
      short_reason: "Roomy family EV with solid range and strong practicality.",
      tradeoff: "Used-price coverage still needs a fuller age-band pass."
    }
  }
];